export var CATEGORY_CARD_SMALL_IMAGE_SIZE = 228;
export var CATEGORY_CARD_MEDIUM_IMAGE_SIZE = 271;